<template>
  <div>
    <div class="detial-cont-title">
      问题整改台账<span class="required">*</span>
    </div>
    <blank height="1"> </blank>
    <div class="detial-cont-view">
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :row-key="(record) => record.id"
      >
        <div slot="order" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>
        <div slot="problemNature" slot-scope="text, record">
          <div class="mb10">
            <p class="stand-label">问题性质：</p>
            <a-select
              :disabled="disabled"
              class="w150 mr20"
              placeholder="请输入问题性质"
              @blur="monitorValue"
              v-model="record.problemNature"
            >
              <a-select-option :value="1"> 一般 </a-select-option>
              <a-select-option :value="2"> 严重 </a-select-option>
            </a-select>
            <p class="stand-label">问题描述：</p>
            <a-input
              :disabled="disabled"
              class="w500"
              placeholder="请输入问题描述"
              @blur="monitorValue"
              v-model="record.problemDesc"
              :maxLength="85"
              @change="eightyfive(record.problemDesc)"
            />
          </div>
          <div class="mb10">
            <p class="stand-label">是否整改：</p>
            <a-select
              v-model="record.rectification"
              placeholder="请选择是否整改"
              class="w150 mr20"
              :disabled="disabled"
            >
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0"> 否 </a-select-option>
            </a-select>
            <p class="stand-label">详细说明：</p>
            <a-input
              :disabled="disabled"
              class="w500"
              placeholder="请输入问题详细说明"
              @blur="monitorValue"
              v-model="record.problemExplain"
              :maxLength="85"
              @change="eightyfive(record.problemExplain)"
            />
          </div>
          <div class="mb10">
            <p class="stand-label">整改情况：</p>
            <a-select
              class="w150 mr20"
              v-model="record.rectificationSituation"
              placeholder="请选择整改情况"
              :disabled="disabled"
            >
              <a-select-option :value="1">已整改</a-select-option>
              <a-select-option :value="0"> 未整改 </a-select-option>
            </a-select>
            <p class="stand-label">未整改原因：</p>
            <a-input
              :disabled="disabled"
              class="w500"
              placeholder="请输入未整改原因"
              @blur="monitorValue"
              v-model="record.rectificationReason"
              :maxLength="85"
              @change="eightyfive(record.rectificationReason)"
            />
          </div>
          <div class="mb10">
            <p class="stand-label">完成时间：</p>
            <a-date-picker
              allowClear
              class="w150 mr20"
              v-model="record.rectificationTime"
              valueFormat="YYYY-MM-DD"
              :disabled="disabled"
            />
          </div>
        </div>
        <!-- <div slot-scope="text, record" slot="problemDesc">
          <a-tooltip placement="topLeft" :title="record.problemDesc">
            <div>
              <a-input
                :disabled="disabled"
                class="ml10"
                placeholder="请输入问题描述"
                @blur="monitorValue"
                v-model="record.problemDesc"
                :maxLength="85"
                @change="eightyfive(record.problemDesc)"
              />
            </div>
          </a-tooltip>
        </div>
        <div slot-scope="text, record" slot="detailedDesc">
          <a-tooltip placement="topLeft" :title="record.problemExplain">
            <div>
              <a-input
                type="textarea"
                :auto-size="{ minRows: 3, maxRows: 6 }"
                :disabled="disabled"
                class="ml10"
                placeholder="请输入问题详细说明"
                @blur="monitorValue"
                v-model="record.problemExplain"
                :maxLength="85"
                @change="eightyfive(record.problemExplain)"
              />
            </div>
          </a-tooltip>
        </div>
        <div slot-scope="text, record" slot="ifRectify">
          <a-select
            v-model="record.rectification"
            placeholder="请选择是否整改"
            style="width: 80px"
            :disabled="disabled"
          >
            <a-select-option :value="1">是</a-select-option>
            <a-select-option :value="0"> 否 </a-select-option>
          </a-select>
        </div>
        <div slot-scope="text, record" slot="rectifyTime">
          <a-date-picker
            allowClear
            class="w200"
            v-model="record.rectificationTime"
            valueFormat="YYYY-MM-DD"
            :disabled="disabled"
          />
        </div>
        <div slot-scope="text, record" slot="rectifyStatus">
          <a-select
            style="width: 80px"
            v-model="record.rectificationSituation"
            placeholder="请选择整改情况"
            :disabled="disabled"
          >
            <a-select-option :value="1">已整改</a-select-option>
            <a-select-option :value="0"> 未整改 </a-select-option>
          </a-select>
        </div>
        <div slot-scope="text, record" slot="unrectifyReason">
          <a-tooltip placement="topLeft" :title="record.rectificationReason">
            <div>
              <a-input
                :disabled="disabled"
                class="ml10"
                placeholder="请输入未整改原因"
                @blur="monitorValue"
                v-model="record.rectificationReason"
                :maxLength="85"
                @change="eightyfive(record.rectificationReason)"
              />
            </div>
          </a-tooltip>
        </div> -->
      </a-table>
      <div class="accessory-btn" v-if="!disabled">
        <a-button icon="plus" @click="addcate">添加问题 </a-button>
      </div>
    </div>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'order',
    key: 'order',
    width: '100px',
    align: 'center',
    scopedSlots: { customRender: 'order' }
  },
  {
    key: 'problemNature',
    scopedSlots: { customRender: 'problemNature' },
    title: '问题整改台账详细信息',
    align: 'left'
  }
  // {
  //   key: "problemDesc",
  //   scopedSlots: { customRender: "problemDesc" },
  //   title: "问题描述",
  //   align: "left"
  // },
  // {
  //   key: "detailedDesc",
  //   scopedSlots: { customRender: "detailedDesc" },
  //   title: "问题详细说明",
  //   align: "left"
  // },
  // {
  //   key: "ifRectify",
  //   scopedSlots: { customRender: "ifRectify" },
  //   title: "是否整改",
  //   align: "left"
  // },
  // {
  //   key: "rectifyTime",
  //   scopedSlots: { customRender: "rectifyTime" },
  //   title: "整改完成时间",
  //   align: "left"
  // },
  // {
  //   key: "rectifyStatus",
  //   scopedSlots: { customRender: "rectifyStatus" },
  //   title: "整改情况",
  //   align: "left"
  // },
  // {
  //   key: "unrectifyReason",
  //   scopedSlots: { customRender: "unrectifyReason" },
  //   title: "未整改原因",
  //   align: "left"
  // }
]
export default {
  props: ['disabled', 'resDetail', 'tableData'],
  model: {
    event: 'input',
    prop: 'tableData'
  },
  data() {
    return {
      columns,
      data: [],
      ifAbleAdd: true
    }
  },
  watch: {
    resDetail(val) {
      if (val) {
        this.data = val
      }
    }
  },
  mounted() {
    this.data = this.resDetail ? this.resDetail : []
  },
  methods: {
    // 输入框限制85
    eightyfive(v) {
      if (v.length > 84) {
        this.$message.destroy()
        this.$message.warning('只能输入85个字')
      }
    },
    // 监听表格行是否都填入输入
    monitorValue() {
      let emitData = []
      this.data.forEach((item) => {
        emitData.push({
          reimbursementDesc: item.reimbursementDesc,
          reimbursementFee: item.reimbursementFee
        })
      })
      this.$emit('input', emitData)
    },
    addcate() {
      this.ifAbleAdd = true
      // 判断当前表格是否含有空数据
      if (this.data && this.data.length != 0) {
        this.data.forEach((item, index) => {
          if (item.reimbursementFee == '' && item.reimbursementDesc == '') {
            this.$message.warning('请先输入当前问题整改台账')
            this.ifAbleAdd = false
          }
        })
      }
      if (this.ifAbleAdd == true) {
        let data = {}
        this.data.push(data)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.detial-cont-title {
  background: #fff;
  height: 55px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 55px;
  text-align: left;
  padding-left: 32px;
}
.detial-cont-view {
  background: #fff;
  padding: 30px;
  .accessory-btn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .stand-label {
    display: inline-block;
    width: 90px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/standingBook/components/standBookTable.vue